import type { GetProductNormalized } from '@messenger/types'
import axios from '@/api/axios.config'

export const getAllProducts = async () => {
  return await axios.get<GetProductNormalized[]>('products')
}
